var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87917 0H3.62083C3.00174 0 2.5 0.501736 2.5 1.12083V2.5H1.12083C0.501736 2.5 0 3.00174 0 3.62083V8.87917C0 9.49826 0.501736 10 1.12083 10H6.37917C6.99826 10 7.5 9.49826 7.5 8.87917V7.5H8.87917C9.49826 7.5 10 6.99826 10 6.37917V1.12083C10 0.501736 9.49826 0 8.87917 0ZM6.38889 8.59826C6.38889 8.75868 6.25868 8.88889 6.09826 8.88889H1.40174C1.24132 8.88889 1.11111 8.75868 1.11111 8.59826V3.90174C1.11111 3.74132 1.24132 3.61111 1.40174 3.61111H6.09792C6.25833 3.61111 6.38854 3.74132 6.38854 3.90174V8.59792L6.38889 8.59826ZM8.88889 6.09826C8.88889 6.25868 8.75868 6.38889 8.59826 6.38889H7.5V3.62083C7.5 3.00174 6.99826 2.5 6.37917 2.5H3.61111V1.40174C3.61111 1.24132 3.74132 1.11111 3.90174 1.11111H8.59792C8.75833 1.11111 8.88854 1.24132 8.88854 1.40174V6.09792L8.88889 6.09826Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.eb5cd966c2ba2da0d2fd38b108dbf70e.svg";
export { ForwardRef as ReactComponent };